// src/guides/GuideBookings.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const GuideBookings = () => {
    const { fetchWithAuth, user, loggedIn, loading: authLoading } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        if (!loggedIn || authLoading || !user?.email) return;

        const fetchBookings = async () => {
            try {
                const encodedEmail = btoa(user.email); // encode to Base64
                const res = await fetchWithAuth(
                    `${API_URL}/bookings?guideEmail=${encodedEmail}`
                );
                if (!res.ok) throw new Error("Failed to fetch bookings");
                const data = await res.json();
                setBookings(data.bookings || []);
            } catch (err) {
                console.error(err);
                setError("Error loading bookings");
            } finally {
                setLoading(false);
            }
        };

        fetchBookings();
    }, [user, loggedIn, authLoading, fetchWithAuth, API_URL]);

    if (authLoading || loading)
        return <p className="guide-bookings-loading">Loading bookings...</p>;
    if (!loggedIn) return <p>Please login to view your bookings.</p>;
    if (error) return <p className="guide-bookings-error">{error}</p>;

    return (
        <section className="guide-bookings-dashboard" aria-label="Your Bookings">
            <h3 className="guide-bookings-heading">📅 Your Bookings</h3>
            {bookings.length === 0 ? (
                <p className="guide-bookings-empty">No bookings yet.</p>
            ) : (
                <ul className="guide-bookings-list">
                    {bookings.map((b) => (
                        <li className="guide-bookings-item" key={b._id}>
                            <div className="booking-traveler">
                                <span className="booking-traveler-name">{b.userName}</span>
                                <span className="booking-traveler-email">{b.userEmail}</span>
                            </div>
                            <div className="booking-info">
                                <time className="guide-bookings-date" dateTime={b.date}>
                                    {new Date(b.date).toLocaleDateString()}
                                </time>
                                <span className={`guide-bookings-status status-${b.status.toLowerCase()}`}>
                                    {b.status}
                                </span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
};

export default GuideBookings;
